export enum EPackageType {
    Coach = "package_coach",
    Plateform = "package_platform"
}
  